import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {GvfService} from "../../../gvf/js/gvf-service";

export class BodyComponent extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        if(this.$root.data("popup-message")){
            swal(
                {
                    type: "info",
                    title: "",
                    text: this.$root.data("popup-message")
                }
            );
        }
        //tooltips functionality
        GvfUiService.ready("[data-toggle=\"tooltip\"]",($element)=>{
            $element.tooltip();
        });

        if(this.$root.hasClass("is-previewing") && window!=window.top){ //previewing and inside an iframe
            this.$root.find("[data-gid]").each((i,el)=>{
                const elementGid = $(el).data("gid");
                if(elementGid){ //is a standard module, not a ref
                    const $editButton = $("<a />");
                    $editButton.attr("href", "#");
                    $editButton.addClass("js-cms-edit-button web-cms-edit-button");
                    $editButton.hide();
                    $editButton.text("Edit");
                    $(el).prepend($editButton);
                    $(el).hover(()=>{
                        this.$root.find(".js-cms-edit-button").hide();
                        $editButton.show();
                    },()=>{
                        $editButton.hide();
                    });
                    $editButton.click((e)=>{
                        e.preventDefault();
                        window.parent.postMessage({
                            type: 'cms-edit-module',
                            data: {gid: elementGid}
                        },'*');
                    });
                    $(el).find("[data-cms-path]").each((j,subel)=>{
                        $(subel).attr("contenteditable",true).blur(
                            ()=>{
                                window.parent.postMessage(
                                    {
                                        type: 'cms-path-update',
                                        data: {gid: elementGid, path: $(subel).data("cms-path"), value: $(subel).html().trim()}
                                    },
                                    '*'
                                );
                            }
                        );
                    });
                }
            });

            window.addEventListener('message', (event)=>{
                const $allCmsPaths = this.$root.find("[data-gid]");
                $allCmsPaths.removeClass("is-cms-highlighted");
                this.$root.find("[data-gid='"+event.data+"']").addClass("is-cms-highlighted");
                GvfService.delay(2000,"cms-highlight").then(()=>{
                    $allCmsPaths.removeClass("is-cms-highlighted");
                });
            });
        }
    }
}
